<ng-container *ngIf="loading; else welcomeView">
	<atomic-loading-icon class="h-[250px]"></atomic-loading-icon>
</ng-container>
<ng-template #welcomeView>
	<div class="flex flex-col p-8 text-xl">
		<div class="w-52 mb-8">
			<img
				src="/assets/images/closer-logos/closer-logo-full.webp"
				alt="Closer logo"
			/>
		</div>
		<div class="connect-to-closer-body-grid-container">
			<div class="font-semibold">
				Simplify conveyancing for real-estate matters through the integration
				between LEAP and Closer
			</div>
			<div class="flex justify-between gap-2">
				<div
					class="px-3 py-1 self-end grow text-center border bg-orange-lightest border-orange-light text-orange-dark; rounded-md font-semibold text-base"
				>
					{{ salePrice | centsToDollars }} Sale matter
				</div>
				<div
					class="px-3 py-1 self-end grow text-center border bg-purple-lighter border-purple-light text-purple-darker rounded-md font-semibold text-base"
				>
					{{ refinancePrice | centsToDollars }} Refinance matter
				</div>
				<div
					class="px-3 py-1 self-end grow text-center border bg-blue-lightest border-blue-light text-blue-dark rounded-md font-semibold text-base"
				>
					{{ purchasePrice | centsToDollars }} Purchase matter
				</div>
			</div>
			<div>
				<iframe
					class="w-full h-full border border-gray-200"
					width="1080px"
					height="608px"
					src="https://www.youtube.com/embed/2TNdYdO8W1E?si=ay-N_6F3pZe0I5KV"
					title="YouTube video player"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					referrerpolicy="strict-origin-when-cross-origin"
					allowfullscreen
				></iframe>
			</div>
			<div class="dashed-border pt-5 pb-4 px-8 flex flex-col justify-between">
				<div class="flex pb-6">
					<app-icon
						[icon]="ICON.CIRCLE_CHECK"
						class="text-emerald-500 text-4xl"
					></app-icon>
					<div class="pl-4">
						<div class="font-semibold text-lg pb-3">
							Receive 10 free matters when you sign up
						</div>
						<div class="text-base">
							New users who create a Closer account will have their LEAP account
							automatically synced to Closer.
						</div>
					</div>
				</div>
				<div class="flex pb-6">
					<app-icon
						[icon]="ICON.CIRCLE_CHECK"
						class="text-emerald-500 text-4xl"
					></app-icon>
					<div class="pl-4">
						<div class="font-semibold text-lg pb-3">
							Centralize your workflow
						</div>
						<div class="text-base">
							Complete conveyancing with data synced between Closer and LEAP,
							all within your LEAP real-estate matter.
						</div>
					</div>
				</div>
				<div class="flex pb-6">
					<app-icon
						[icon]="ICON.CIRCLE_CHECK"
						class="text-emerald-500 text-4xl text-"
					></app-icon>
					<div class="pl-4">
						<div class="font-semibold text-lg pb-3">
							Know exactly what you pay
						</div>
						<div class="text-base">
							With a 2-year price guarantee, you'll know the price of your
							conveyancing fees is set.
						</div>
					</div>
				</div>
				<div class="pb-1">
					<ui-button
						classes="w-full py-1 text-lg"
						label="Connect to Closer"
						(click)="handleConnectToCloserClick()"
					></ui-button>
				</div>
			</div>
		</div>

		<div class="grid grid-cols-4 gap-5 mt-6">
			<div
				class="flex flex-col items-center pb-4 px-4 border border-gray-200 rounded-lg"
			>
				<app-icon
					[icon]="ICON.CALENDAR_CLOCK"
					class="text-emerald-500 text-4xl m-4"
				></app-icon>
				<div class="text-center font-semibold text-base px-4">
					Smart planner to prioritize your key tasks and closings
				</div>
			</div>
			<div
				class="flex flex-col items-center pb-4 px-4 border border-gray-200 rounded-lg"
			>
				<app-icon
					[icon]="ICON.FILE_CHECK"
					class="text-emerald-500 text-4xl m-4"
				></app-icon>
				<div class="text-center font-semibold text-base px-4">
					Jumpstart with prebuilt document templates
				</div>
			</div>
			<div
				class="flex flex-col items-center pb-4 px-4 border border-gray-200 rounded-lg"
			>
				<app-icon
					[icon]="ICON.CIRCLE_CHECK"
					class="text-emerald-500 text-4xl m-4"
				></app-icon>
				<div class="text-center font-semibold text-base px-4">
					Keep tabs on matters with intuitive progress bars
				</div>
			</div>
			<div
				class="flex flex-col items-center pb-4 px-4 border border-gray-200 rounded-lg"
			>
				<app-icon
					[icon]="ICON.PLUG"
					class="text-emerald-500 text-4xl m-4"
				></app-icon>
				<div class="text-center font-semibold text-base px-4">
					Seamlessly sync with the platforms you trust
				</div>
			</div>
		</div>

		<div
			class="flex justify-between items-center border border-gray-200 rounded-lg h-20 p-4 mt-6 bg-gray-50"
		>
			<div class="h-full flex items-center">
				<img
					class="h-3/4"
					src="/assets/images/integrations/treefort-logo.svg"
					alt="Treefort"
				/>
			</div>
			<div class="h-full flex items-center">
				<img
					class="h-3/4"
					src="/assets/images/integrations/teranet-logo-no-bg.png"
					alt="Teranet"
				/>
			</div>
			<div class="h-full">
				<img
					class="h-full"
					src="/assets/images/integrations/llc-logo-no-bg.png"
					alt="LLC"
				/>
			</div>
			<div class="h-full">
				<img
					class="h-full"
					src="/assets/images/integrations/sync-logo.png"
					alt="Sync"
				/>
			</div>
			<div class="h-full">
				<img
					class="h-full"
					src="/assets/images/integrations/fct-logo.svg"
					alt="FCT"
				/>
			</div>
			<div class="h-full">
				<img
					class="h-full"
					src="/assets/images/integrations/chicago-title-logo.svg"
					alt="Chicago Title"
				/>
			</div>
			<div class="h-full">
				<img
					class="h-full"
					src="/assets/images/integrations/title-plus-logo.svg"
					alt="Title Plus"
				/>
			</div>
			<div class="h-full">
				<img
					class="h-full"
					src="/assets/images/integrations/stewart-title-logo.svg"
					alt="Stewart Title"
				/>
			</div>
		</div>
		<div class="flex justify-center text-emerald-700 mt-6">
			<a href="https://lawlabs.ca" (click)="goToLawlabsWebsite($event)">
				<app-icon [icon]="ICON.EXTERNAL" class="text-sm"></app-icon>
				<span class="text-lg ml-2">Visit Closer's website to explore more</span>
			</a>
		</div>
	</div>
</ng-template>
